import React from "react";
import Context from "../../../Context";
import List from "../../Misc/List";
import Sortings from "../../Misc/Sortings";
import WorkdocListItem from "./WorkdocListItem";
import { Link } from "react-router-dom";
import WorkdocTypedocList from "./WorkdocTypedocList";
import Searchbox from "../../Misc/Searchbox";
import { getKeysByCriteria } from "./typedoc";

export default class WorkdocList extends React.Component {
  static contextType = Context;
  static fieldsStorageName = "templateListFields";
  constructor(props) {
    super(props);

    this.state = {
      typedocListShow: false,
      pending: false,
      search: [],
      customListKey: "",
      filters: props.filters,
      fields: {
        all: [],
        active: [],
      },
      sortings: {
        all: [
          {
            id: "byTypeAsc",
            active: false,
            title: "По типу",
            value: ["typecode ASC"],
          },
          {
            id: "byLabelAsc",
            active: false,
            title: "По алфавиту",
            value: ["label ASC"],
          },
          {
            id: "byCreatedDesc",
            active: false,
            title: "По дате создания",
            value: ["created DESC"],
          },
        ],
        active: [],
      },
    };
  }
  componentDidMount() {
    this.setDefaultFilters();
    this.loadRespondDoc();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.structureId !== this.props.structureId ||
      prevProps.listMode !== this.props.listMode
    ) {
      this.setDefaultFilters();
    }
    if (prevProps.respond !== this.props.respond) {
      this.loadRespondDoc();
    }
  }

  setDefaultFilters = () => {
    this.setState((state) => {
      let filters = this.props.filters;
      filters.default = [];
      if (this.props.listMode) {
        //Owner
        if (this.props.listMode === "me") {
          filters.default.push({
            lstr: "(",
            field: "owner",
            compare: "NEQ",
            value: this.context.user.id,
            rstr: ")",
          });
        }
        if (this.props.listMode === "my" || this.props.listMode === "draft") {
          filters.default.push({
            lstr: "(",
            field: "owner",
            compare: "EQL",
            value: this.context.user.id,
            rstr: ")",
          });
        }

        //Class
        if (this.props.listMode !== "add") {
          filters.default.push({
            lstr: "(",
            field: "classcode",
            valarr: getKeysByCriteria("inWorkdoc"),
            rstr: ")",
          });
        } else {
          filters.default.push({
            lstr: "(",
            field: "classcode",
            compare: "EQL",
            value: "template",
            rstr: ")",
          });
        }

        //Structure
        if (this.props.structureId && this.props.structureId !== "any") {
          filters.default.push({
            lstr: "(",
            field: "structure",
            compare: "EQL",
            value: this.props.structureId,
            rstr: ")",
          });
        }

        //Status
        if (this.props.listMode === "add") {
          filters.default.push({
            lstr: "(",
            field: "statetypecode",
            compare: "EQL",
            value: "disabled",
            rstr: ")",
          });
        }

        if (this.props.listMode === "draft") {
          filters.default.push({
            lstr: "(",
            field: "statecode",
            compare: "EQL",
            value: "created",
          });
          filters.default.push({
            condition: "OR",
            field: "statecode",
            compare: "EQL",
            value: "deleted",
            rstr: ")",
          });
        }

        if (this.props.listMode === "me") {
          filters.default.push({
            lstr: "(",
            field: "statecode",
            compare: "NEQ",
            value: "created",
            rstr: ")",
          });
          filters.default.push({
            lstr: "(",
            field: "statecode",
            compare: "NEQ",
            value: "deleted",
            rstr: ")",
          });
        }

        if (this.props.listMode === "my") {
          filters.default.push({
            lstr: "(",
            field: "statecode",
            compare: "NEQ",
            value: "created",
            rstr: ")",
          });
          filters.default.push({
            lstr: "(",
            field: "statecode",
            compare: "NEQ",
            value: "deleted",
            rstr: ")",
          });
        }
      }
      return filters;
    });
  };

  loadRespondDoc = async () => {
    if (this.props.respond) {
      let respondDoc = await this.context.api.q("/manual/get", {
        id: this.props.respond,
      });
      this.setState({ respondDoc });
    } else {
      this.setState({ respondDoc: false });
    }
  };

  toggleFilters = (v) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.show = v;
      return { filters };
    });
  };

  handleFilters = (changedFilters) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.active = changedFilters;
      return { filters };
    });
  };
  handleFields = (changedFields) => {
    localStorage.setItem(this.fieldsStorageName, JSON.stringify(changedFields));
    this.setState((state) => {
      let fields = state.fields;
      fields.active = changedFields;
      return { fields };
    });
  };
  handleSortings = (chnagedSortings) => {
    this.setState((state) => {
      let sortings = state.sortings;
      sortings.active = chnagedSortings;
      return { sortings };
    });
  };
  onSearch = (searchValue) => {
    let search = searchValue
      ? [
          {
            lstr: "(",
            field: "label",
            compare: "IKE",
            value: `%${searchValue}%`,
            rstr: ")",
          },
        ]
      : [];
    this.setState({
      search,
    });
  };

  onFinish = () => {
    this.setState({ customListKey: this.context.key() });
  };

  onListLoadStart = () => {
    this.setState({ pending: true });
  };
  onListLoadEnd = () => {
    this.setState({ pending: false });
  };

  onTypedocListShow = () => {
    this.setState({ typedocListShow: true });
  };
  onTypedocListHide = () => {
    this.setState({ typedocListShow: false });
  };

  render() {
    return (
      <>
        {this.state.typedocListShow && (
          <WorkdocTypedocList onHide={this.onTypedocListHide} />
        )}

        {this.props.listMode === "add" ? (
          <div className="mb-4 text-muted d-flex justify-content-between align-items-center">
            <h6>По шаблону:</h6>
            <div>
              <div className="btn btn-light" onClick={this.onTypedocListShow}>
                Из встроенных...
              </div>
            </div>
          </div>
        ) : null}

        {this.state.respondDoc && (
          <div className="mb-4 text-dark-50">
            В ответ на
            <Link
              className="ml-2"
              to={`/workdoc/default/any/${this.state.respondDoc.id}/`}
            >
              {this.state.respondDoc.label}
            </Link>
            <Link to={`/workdoc/add/any/`} className="ml-2">
              <i className="fa fa-times" title="Не отвечать"></i>
            </Link>
          </div>
        )}

        <div className="d-flex mb-4">
          <div className="text-nowrap flex-grow-1 mr-2">
            <Searchbox onSearch={this.onSearch} />
          </div>

          <Sortings
            changeFn={this.handleSortings}
            sortings={this.state.sortings.all}
          />
        </div>

        <List
          listKey="TemplatesList"
          key={this.state.customListKey}
          fulltext={JSON.stringify(this.state.search)}
          search={JSON.stringify(
            this.state.filters.active.concat(this.state.filters.default)
          )}
          sort={JSON.stringify(this.state.sortings.active)}
          fields={JSON.stringify(this.state.fields.active)}
          limit={150}
          hideSinglePageNav={true}
          keyField="id"
          path="/document/list"
          row={this.state.viewGrid}
          onLoadStart={this.onListLoadStart}
          onLoadEnd={this.onListLoadEnd}
          blocker={{ spinnerFixed: true, hAuto: true }}
          currentItem={this.props.itemId}
          multiselect
        >
          <WorkdocListItem
            highlightItem={this.props.itemId}
            structureId={this.props.structureId}
            listMode={this.props.listMode}
            onDrop={this.onFinish}
          />
        </List>
      </>
    );
  }
}
